const environment = `${process.env.REACT_APP_API}`;

// Environment configurations
const configMap = {
  local: {
    apiUrl: process.env.REACT_APP_API_LOCAL,
  },
  staging: {
    apiUrl: process.env.REACT_APP_API_STAGING,
  },
  beta: {
    apiUrl: process.env.REACT_APP_API_BETA,
  },
  production: {
    apiUrl: process.env.REACT_APP_API_PRODUCTION,
  },
};

// Export based on environment with fallback to local
const config = configMap[environment] || configMap.local;

export const apiUrl = config.apiUrl;
export default config;
